"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validScrollableValues = exports.oneOfAlignments = exports.oneOfBreakpoints = exports.WIDTHS = exports.ALIGNMENTS = void 0;

var _propTypes = require("prop-types");

var ALIGNMENTS = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
exports.ALIGNMENTS = ALIGNMENTS;
var WIDTHS = {
  5: '5',
  10: '10',
  15: '15',
  16: '16',
  20: '20',
  25: '25',
  30: '30',
  33: '33',
  35: '35',
  40: '40',
  45: '45',
  50: '50',
  55: '55',
  60: '60',
  65: '65',
  66: '66',
  70: '70',
  75: '75',
  80: '80',
  85: '85',
  90: '90',
  95: '95',
  100: '100'
};
exports.WIDTHS = WIDTHS;
var oneOfBreakpoints = (0, _propTypes.oneOf)(Object.values(WIDTHS));
exports.oneOfBreakpoints = oneOfBreakpoints;
var oneOfAlignments = (0, _propTypes.oneOf)(Object.values(ALIGNMENTS));
exports.oneOfAlignments = oneOfAlignments;
var validScrollableValues = [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000];
exports.validScrollableValues = validScrollableValues;